import {Injectable} from '@angular/core';
import {HomePageMenuItems as Fas44MenuItems} from '../../lib/data/fas44-home-page-data';
import {HomePageMenuItems as Fas45MenuItems} from '../data/fas45-home-page-data';
import {HomePageMenuItems as Far45MenuItems} from '../../lib/data/far45-home-page-data';
import {HomePageMenuItems as Bafq43MenuItems} from '../data/bafq43-home-page-data';
import {HomePageMenuItems as Bafr43MenuItems} from '../data/bafr43-home-page-data';
import {HomePageMenuItems as Baq43bMenuItems} from '../data/baq43b-home-page-data';
import {HomePageMenuItems as Bar47MenuItems} from '../data/bar47-home-page-data';
import {HomePageMenuItems as Bas47MenuItems} from '../data/bas47-home-page-data';
import {HomePageMenuItems as Cafq43MenuItems} from '../data/cafq43-home-page-data';
import {HomePageMenuItems as Cafr43MenuItems} from '../data/cafr43-home-page-data';
import {HomePageMenuItems as Caq43bMenuItems} from '../data/caq43b-home-page-data';
import {HomePageMenuItems as Car47MenuItems} from '../data/car47-home-page-data';
import {HomePageMenuItems as Cas47MenuItems} from '../data/cas47-home-page-data';
import {HomePageMenuItems as Enar43MenuItems} from '../data/enar43-home-page-data';
import {HomePageMenuItems as Enas44MenuItems} from '../data/enas44-home-page-data';
import {HomePageMenuItems as Daq42MenuItems} from '../data/daq42-home-page-data';
import {HomePageMenuItems as Dar42MenuItems} from '../data/dar42-home-page-data';
import {HomePageMenuItems as Das43MenuItems} from '../data/das43-home-page-data';
import {HomePageMenuItems as Awhr43MenuItems} from '../data/awhr43-home-page-data';
import {HomePageMenuItems as Eahs44MenuItems} from '../data/eahs44-home-page-data';
import {HomePageMenuItems as Faq42MenuItems} from '../data/faq42-home-page-data';
import {HomePageMenuItems as Feq42MenuItems} from '../data/feq42-home-page-data';
import {HomePageMenuItems as Fer42MenuItems} from '../data/fer42-home-page-data';
import {HomePageMenuItems as Fes43MenuItems} from '../data/fes43-home-page-data';
import {HomePageMenuItems as Heano42MenuItems} from '../data/heano42-home-page-data';
import {HomePageMenuItems as Heano43MenuItems} from '../data/heano43-home-page-data';
import {HomePageMenuItems as Mwhr43MenuItems} from '../data/mwhr43-home-page-data';
import {HomePageMenuItems as Pafq43MenuItems} from '../data/pafq43-home-page-data';
import {HomePageMenuItems as Pafr43MenuItems} from '../data/pafr43-home-page-data';
import {HomePageMenuItems as Paq43bMenuItems} from '../data/paq43-home-page-data';
import {HomePageMenuItems as Par49MenuItems} from '../data/par49-home-page-data';
import {HomePageMenuItems as Pas49MenuItems} from '../data/pas49-home-page-data';
import {HomePageMenuItems as Safq43bMenuItems} from '../data/safq43-home-page-data';
import {HomePageMenuItems as Safr47MenuItems} from '../data/safr47-home-page-data';
import {HomePageMenuItems as Sahq43bMenuItems} from '../data/sahq43-home-page-data';
import {HomePageMenuItems as Sahr47MenuItems} from '../data/sahr47-home-page-data';
import {HomePageMenuItems as Scafs43MenuItems} from '../data/scafs43-home-page-data';
import {HomePageMenuItems as Scahs43MenuItems} from '../data/scahs43-home-page-data';
import {HomePageMenuItems as Spaq42MenuItems} from '../data/spaq42-home-page-data';
import {HomePageMenuItems as Spar42MenuItems} from '../data/spar42-home-page-data';
import {HomePageMenuItems as Spas43MenuItems} from '../data/spas43-home-page-data';
import {HomePageMenuItems as Speq42MenuItems} from '../data/speq42-home-page-data';
import {HomePageMenuItems as Sper42MenuItems} from '../data/sper42-home-page-data';
import {HomePageMenuItems as Spes43MenuItems} from '../data/spes43-home-page-data';
import { HomePageMenuItems as Trhp20MenuItems } from '../data/test/trhp20-home-page-data';
import { HomePageMenuItems as Trhp21MenuItems } from '../data/test/trhp21-home-page-data';
import { HomePageMenuItems as Trhp22MenuItems } from '../data/test/trhp22-home-page-data';
import { HomePageMenuItems as Trhp23MenuItems } from '../data/test/trhp23-home-page-data';
import { HomePageMenuItems as Trhp24MenuItems } from '../data/test/trhp24-home-page-data';
import { HomePageMenuItems as Trhp25MenuItems } from '../data/test/trhp25-home-page-data';
import { HomePageMenuItems as Trhp26MenuItems } from '../data/test/trhp26-home-page-data';
import { HomePageMenuItems as Trhp27MenuItems } from '../data/test/trhp27-home-page-data';
import { HomePageMenuItems as Trhp28MenuItems } from '../data/test/trhp28-home-page-data';
import { HomePageMenuItems as Trhp29MenuItems } from '../data/test/trhp29-home-page-data';

import {DigitalProductPageItem as Fas44DigitalMenuItem} from '../data/digital-page-data/fas44-digital-page-data';

import {
  DigitalProductPageItem as Fas44DigitalSampleMenuItem
} from '../data/digital-page-data/samples/fas44-digital-page-sample-data';
import {
  DigitalProductPageItem as Das43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/das43-digital-page-sample-data';

import {DigitalProductPageItem as Fas45DigitalMenuItem} from '../data/digital-page-data/fas45-digital-page-data';
import {DigitalProductPageItem as Enar43DigitalMenuItem} from '../data/digital-page-data/enar43-digital-page-data';
import {DigitalProductPageItem as Daq42DigitalMenuItem} from '../data/digital-page-data/daq42-digital-page-data';
import {DigitalProductPageItem as Awhr43DigitalMenuItem} from '../data/digital-page-data/awhr43-digital-page-data';
import {DigitalProductPageItem as Heano42DigitalMenuItem} from '../data/digital-page-data/heano42-digital-page-data';
import {DigitalProductPageItem as Heano43DigitalMenuItem} from '../data/digital-page-data/heano43-digital-page-data';
import {DigitalProductPageItem as Far45DigitalMenuItem} from '../data/digital-page-data/far45-digital-page-data';
import {DigitalProductPageItem as Car47DigitalMenuItem} from '../data/digital-page-data/car47-digital-page-data';
import {DigitalProductPageItem as Bafq43DigitalMenuItem} from '../data/digital-page-data/bafq43-digital-page-data';
import {DigitalProductPageItem as Bafr43DigitalMenuItem} from '../data/digital-page-data/bafr43-digital-page-data';
import {DigitalProductPageItem as Baq43bDigitalMenuItem} from '../data/digital-page-data/baq43b-digital-page-data';
import {DigitalProductPageItem as Bar47DigitalMenuItem} from '../data/digital-page-data/bar47-digital-page-data';
import {DigitalProductPageItem as Bas47DigitalMenuItem} from '../data/digital-page-data/bas47-digital-page-data';
import {DigitalProductPageItem as Cafq43DigitalMenuItem} from '../data/digital-page-data/cafq43-digital-page-data';
import {DigitalProductPageItem as Cafr43DigitalMenuItem} from '../data/digital-page-data/cafr43-digital-page-data';
import {DigitalProductPageItem as Caq43bDigitalMenuItem} from '../data/digital-page-data/caq43b-digital-page-data';
import {DigitalProductPageItem as Cas47DigitalMenuItem} from '../data/digital-page-data/cas47-digital-page-data';
import {DigitalProductPageItem as Dar42DigitalMenuItem} from '../data/digital-page-data/dar42-digital-page-data';
import {DigitalProductPageItem as Das43DigitalMenuItem} from '../data/digital-page-data/das43-digital-page-data';
import {DigitalProductPageItem as Enas44DigitalMenuItem} from '../data/digital-page-data/enas44-digital-page-data';
import {DigitalProductPageItem as Faq42DigitalMenuItem} from '../data/digital-page-data/faq42-digital-page-data';
import {DigitalProductPageItem as Feq42DigitalMenuItem} from '../data/digital-page-data/feq42-digital-page-data';
import {DigitalProductPageItem as Fer42DigitalMenuItem} from '../data/digital-page-data/fer42-digital-page-data';
import {DigitalProductPageItem as Fes43DigitalMenuItem} from '../data/digital-page-data/fes43-digital-page-data';
import {DigitalProductPageItem as Pafq43DigitalMenuItem} from '../data/digital-page-data/pafq43-digital-page-data';
import {DigitalProductPageItem as Pafr43DigitalMenuItem} from '../data/digital-page-data/pafr43-digital-page-data';
import {DigitalProductPageItem as Paq43bDigitalMenuItem} from '../data/digital-page-data/paq43-digital-page-data';
import {DigitalProductPageItem as Par49DigitalMenuItem} from '../data/digital-page-data/par49-digital-page-data';
import {DigitalProductPageItem as Pas49DigitalMenuItem} from '../data/digital-page-data/pas49-digital-page-data';
import {DigitalProductPageItem as Safq43bDigitalMenuItem} from '../data/digital-page-data/safq43-digital-page-data';
import {DigitalProductPageItem as Safr47DigitalMenuItem} from '../data/digital-page-data/safr47-digital-page-data';
import {DigitalProductPageItem as Sahq43bDigitalMenuItem} from '../data/digital-page-data/sahq43-digital-page-data';
import {DigitalProductPageItem as Sahr47DigitalMenuItem} from '../data/digital-page-data/sahr47-digital-page-data';
import {DigitalProductPageItem as Scafs43DigitalMenuItem} from '../data/digital-page-data/scafs43-digital-page-data';
import {DigitalProductPageItem as Scahs43DigitalMenuItem} from '../data/digital-page-data/scahs43-digital-page-data';
import {DigitalProductPageItem as Spaq42DigitalMenuItem} from '../data/digital-page-data/spaq42-digital-page-data';
import {DigitalProductPageItem as Spar42DigitalMenuItem} from '../data/digital-page-data/spar42-digital-page-data';
import {DigitalProductPageItem as Spas43DigitalMenuItem} from '../data/digital-page-data/spas43-digital-page-data';
import {DigitalProductPageItem as Speq42DigitalMenuItem} from '../data/digital-page-data/speq42-digital-page-data';
import {DigitalProductPageItem as Sper42DigitalMenuItem} from '../data/digital-page-data/sper42-digital-page-data';
import {DigitalProductPageItem as Spes43DigitalMenuItem} from '../data/digital-page-data/spes43-digital-page-data';
import {DigitalProductPageItem as Eahs44DigitalMenuItem} from '../data/digital-page-data/eahs44-digital-page-data';
import {DigitalProductPageItem as Mwhr43DigitalMenuItem} from '../data/digital-page-data/mwhr43-digital-page-data';
import {DigitalProductPageItem as Heawo43DigitalMenuItem} from '../data/digital-page-data/heawo43-digital-page-data';
import {DigitalProductPageItem as Hecpo43DigitalMenuItem} from '../data/digital-page-data/hecpo43-digital-page-data';
import {DigitalProductPageItem as Eti46DigitalMenuItem} from '../data/digital-page-data/eti46-digital-page-data';
import {DigitalProductPageItem as Hembo43DigitalMenuItem} from '../data/digital-page-data/hembo43-digital-page-data';
import {DigitalProductPageItem as Hewno43DigitalMenuItem} from '../data/digital-page-data/hewno43-digital-page-data';
import {DigitalProductPageItem as Hecwo43DigitalMenuItem} from '../data/digital-page-data/hecwo43-digital-page-data';
import {DigitalProductPageItem as Heeao43DigitalMenuItem} from '../data/digital-page-data/heeao43-digital-page-data';
import {DigitalProductPageItem as Etm45DigitalMenuItem} from '../data/digital-page-data/etm45-digital-page-data';
import {DigitalProductPageItem as Etcc43DigitalMenuItem} from '../data/digital-page-data/etcc43-digital-page-data';
import {DigitalProductPageItem as Etr46DigitalMenuItem} from '../data/digital-page-data/etr46-digital-page-data';
import {DigitalProductPageItem as Etjh43DigitalMenuItem} from '../data/digital-page-data/etjh43-digital-page-data';
import {DigitalProductPageItem as Etbb43DigitalMenuItem} from '../data/digital-page-data/etbb43-digital-page-data';
import {DigitalProductPageItem as Eta45DigitalMenuItem} from '../data/digital-page-data/eta45-digital-page-data';
import {DigitalProductPageItem as Etl46DigitalMenuItem} from '../data/digital-page-data/etl46-digital-page-data';
import {DigitalProductPageItem as Etf43DigitalMenuItem} from '../data/digital-page-data/etf43-digital-page-data';
import {DigitalProductPageItem as Etma43DigitalMenuItem} from '../data/digital-page-data/etma43-digital-page-data';
import {DigitalProductPageItem as Etmv43DigitalMenuItem} from '../data/digital-page-data/etmv43-digital-page-data';
import {DigitalProductPageItem as Etje43DigitalMenuItem} from '../data/digital-page-data/etje43-digital-page-data';
import {DigitalProductPageItem as Etsf43DigitalMenuItem} from '../data/digital-page-data/etsf43-digital-page-data';
import {DigitalProductPageItem as Etp46DigitalMenuItem} from '../data/digital-page-data/etp46-digital-page-data';
import {DigitalProductPageItem as Etg45DigitalMenuItem} from '../data/digital-page-data/etg45-digital-page-data';
import {DigitalProductPageItem as Baq72DigitalMenuItem} from '../data/digital-page-data/baq72-digital-page-data';
import {DigitalProductPageItem as Bar74DigitalMenuItem} from '../data/digital-page-data/bar74-digital-page-data';
import {DigitalProductPageItem as Caq72DigitalMenuItem} from '../data/digital-page-data/caq72-digital-page-data';
import {DigitalProductPageItem as Car74DigitalMenuItem} from '../data/digital-page-data/car74-digital-page-data';
import {DigitalProductPageItem as Paq72DigitalMenuItem} from '../data/digital-page-data/paq72-digital-page-data';
import {DigitalProductPageItem as Par74DigitalMenuItem} from '../data/digital-page-data/par74-digital-page-data';
import {DigitalProductPageItem as Mcfq44DigitalMenuItem} from '../data/digital-page-data/mcfq44-digital-page-data';
import { DigitalProductPageItem as Trhp20DigitalMenuItem } from '../data/digital-page-data/test/trhp20-digital-page-data';
import { DigitalProductPageItem as Trhp21DigitalMenuItem } from '../data/digital-page-data/test/trhp21-digital-page-data';
import { DigitalProductPageItem as Trhp22DigitalMenuItem } from '../data/digital-page-data/test/trhp22-digital-page-data';
import { DigitalProductPageItem as Trhp23DigitalMenuItem } from '../data/digital-page-data/test/trhp23-digital-page-data';
import { DigitalProductPageItem as Trhp24DigitalMenuItem } from '../data/digital-page-data/test/trhp24-digital-page-data';
import { DigitalProductPageItem as Trhp25DigitalMenuItem } from '../data/digital-page-data/test/trhp25-digital-page-data';
import { DigitalProductPageItem as Trhp26DigitalMenuItem } from '../data/digital-page-data/test/trhp26-digital-page-data';
import { DigitalProductPageItem as Trhp27DigitalMenuItem } from '../data/digital-page-data/test/trhp27-digital-page-data';
import { DigitalProductPageItem as Trhp28DigitalMenuItem } from '../data/digital-page-data/test/trhp28-digital-page-data';
import { DigitalProductPageItem as Trhp29DigitalMenuItem } from '../data/digital-page-data/test/trhp29-digital-page-data';

//SAMPLE PRODUCTS
import {HomePageMenuItems as Fas44SampleMenuItems} from '../data/samples/fas44-home-page-sample-data';
import {HomePageMenuItems as Car47SampleMenuItems} from '../data/samples/car47-home-page-sample-data';
import {HomePageMenuItems as Enar43SampleMenuItems} from '../data/samples/enar43-home-page-sample-data';
import {HomePageMenuItems as Das43SampleMenuItems} from '../data/samples/das43-home-page-sample-data';
import {HomePageMenuItems as Spas43SampleMenuItems} from '../data/samples/spas43-home-page-sample-data';
import {HomePageMenuItems as Scahs43SampleMenuItems} from '../data/samples/scahs43-home-page-sample-data';
import {HomePageMenuItems as Paq43SampleMenuItems} from '../data/samples/paq43-home-page-sample-data';
import { HomePageMenuItems as Baq43SampleMenuItems } from '../data/samples/baq43-home-page-sample-data';
import { HomePageMenuItems as Caq43SampleMenuItems } from '../data/samples/caq43-home-page-sample-data';
import {HomePageMenuItems as Bar47SampleMenuItems} from '../data/samples/bar47-home-page-sample-data';
import {HomePageMenuItems as MHQ48SampleMenuItems} from '../data/samples/mhq48-home-page-sample-data';
import {HomePageMenuItems as MFQ48SampleMenuItems} from '../data/samples/mfq48-home-page-sample-data';
import {HomePageMenuItems as Heawo43MenuItems} from '../data/heawo43-home-page-data';
import {HomePageMenuItems as Hecpo43MenuItems} from '../data/hecpo43-home-page-data';
import {HomePageMenuItems as Eti46MenuItems} from '../data/eti46-home-page-data';
import {HomePageMenuItems as Hembo43MenuItems} from '../data/hembo43-home-page-data';
import {HomePageMenuItems as Hewno43MenuItems} from '../data/hewno43-home-page-data';
import {HomePageMenuItems as Hecwo43MenuItems} from '../data/hecwo43-home-page-data';
import {HomePageMenuItems as Heeao43MenuItems} from '../data/heeao43-home-page-data';
import {HomePageMenuItems as Etm45MenuItems} from '../data/etm45-home-page-data';
import {HomePageMenuItems as Etcc43MenuItems} from '../data/etcc43-home-page-data';
import {HomePageMenuItems as Etr46MenuItems} from '../data/etr46-home-page-data';
import {HomePageMenuItems as Etjh43MenuItems} from '../data/etjh43-home-page-data';
import {HomePageMenuItems as Etbb43MenuItems} from '../data/etbb43-home-page-data';
import {HomePageMenuItems as Eta45MenuItems} from '../data/eta45-home-page-data';
import {HomePageMenuItems as Etl46MenuItems} from '../data/etl46-home-page-data';
import {HomePageMenuItems as Etf43MenuItems} from '../data/etf43-home-page-data';
import {HomePageMenuItems as Etma43MenuItems} from '../data/etma43-home-page-data';
import {HomePageMenuItems as Etmv43MenuItems} from '../data/etmv43-home-page-data';
import {HomePageMenuItems as Etje43MenuItems} from '../data/etje43-home-page-data';
import {HomePageMenuItems as Etsf43MenuItems} from '../data/etsf43-home-page-data';
import {HomePageMenuItems as Etp46MenuItems} from '../data/etp46-home-page-data';
import {HomePageMenuItems as Etg45MenuItems} from '../data/etg45-home-page-data';
import {HomePageMenuItems as Baq72MenuItems} from '../data/baq72-home-page-data';
import {HomePageMenuItems as Bar74MenuItems} from '../data/bar74-home-page-data';
import {HomePageMenuItems as Caq72MenuItems} from '../data/caq72-home-page-data';
import {HomePageMenuItems as Car74MenuItems} from '../data/car74-home-page-data';
import {HomePageMenuItems as Paq72MenuItems} from '../data/paq72-home-page-data';
import {HomePageMenuItems as Par74MenuItems} from '../data/par74-home-page-data';
import {HomePageMenuItems as Mcfq44MenuItems} from '../data/mcfq44-home-page-data';
import {HomePageMenuItems as Mhq48MenuItems} from '../data/mhq48-home-page-data';
import {HomePageMenuItems as Mfq48MenuItems} from '../data/mfq48-home-page-data';
import {HomePageMenuItems as Mchq44MenuItems} from '../data/mchq44-home-page-data';
import {HomePageMenuItems as Bar74SampleMenuItems} from '../data/samples/bar74-home-page-sample-data';
import {HomePageMenuItems as Caq72SampleMenuItems} from '../data/samples/caq72-home-page-sample-data';
import {HomePageMenuItems as Eti46SampleMenuItems} from '../data/samples/eti46-home-page-sample-data';
import {HomePageMenuItems as Mhs49MenuItems} from '../data/mhs49-home-page-data';
import {HomePageMenuItems as Mhr141MenuItems} from '../data/mhr141-home-page-data';
import {HomePageMenuItems as Mchr48MenuItems} from '../data/mchr48-home-page-data';
import {HomePageMenuItems as Mchs42MenuItems} from '../data/mchs42-home-page-data';
import {HomePageMenuItems as Mcfr49MenuItems} from '../data/mcfr49-home-page-data';
import {HomePageMenuItems as Mcfs42MenuItems} from '../data/mcfs42-home-page-data';
import {HomePageMenuItems as Mfr141MenuItems} from '../data/mfr141-home-page-data';
import {HomePageMenuItems as Mfs49MenuItems} from '../data/mfs49-home-page-data';
import {HomePageMenuItems as Acehr43MenuItems} from '../data/acehr43-home-page-data';
import {HomePageMenuItems as Achr45MenuItems} from '../data/achr45-home-page-data';
import {HomePageMenuItems as Achr45SampleMenuItems} from '../data/samples/achr45-home-page-sample-data';
import {HomePageMenuItems as Alhr42MenuItems} from '../data/alhr42-home-page-data';
import {HomePageMenuItems as Arehr43MenuItems} from '../data/arehr43-home-page-data';
import {HomePageMenuItems as Arhr45MenuItems} from '../data/arhr45-home-page-data';
import {HomePageMenuItems as Hecwo43SampleMenuItems} from '../data/samples/hecwo43-home-page-sample-data';

//SAMPLE PAGE DATA
import {
  DigitalProductPageItem as Car47DigitalSampleMenuItem
} from '../data/digital-page-data/samples/car47-digital-page-sample-data';
import {
  DigitalProductPageItem as Enar43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/enar43-digital-page-sample-data';
import {
  DigitalProductPageItem as Spas43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/spas43-digital-page-sample-data';
import {
  DigitalProductPageItem as Scahs43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/scahs43-digital-page-sample-data';
import {
  DigitalProductPageItem as Paq43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/paq43-digital-page-sample-data';
import {
  DigitalProductPageItem as Baq43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/baq43-digital-page-sample-data';
import {
  DigitalProductPageItem as Caq43DigitalSampleMenuItem
} from '../data/digital-page-data/samples/caq43-digital-page-sample-data';
import {
  DigitalProductPageItem as Bar47DigitalSampleMenuItem
} from '../data/digital-page-data/samples/bar47-digital-page-sample-data'
import {DigitalProductPageItem as Bar74DigitalSampleMenuItem} from '../data/digital-page-data/samples/bar74-digital-page-sample-data';
import {DigitalProductPageItem as Caq72DigitalSampleMenuItem} from '../data/digital-page-data/samples/caq72-digital-page-sample-data';
import {DigitalProductPageItem as Eti46DigitalSampleMenuItem} from '../data/digital-page-data/samples/eti46-digital-page-sample-data';
import {DigitalProductPageItem as Mchq44DigitalSampleMenuItem} from '../data/digital-page-data/samples/mchq44-digital-page-sample-data';
import {DigitalProductPageItem as Mcfq44DigitalSampleMenuItem} from '../data/digital-page-data/samples/mcfq44-digital-page-sample-data';
import {DigitalProductPageItem as MHQ48DigitalSampleMenuItem} from '../data/digital-page-data/samples/mhq48-digital-page-sample-data';
import {DigitalProductPageItem as MFQ48DigitalSampleMenuItem} from '../data/digital-page-data/samples/mfq48-digital-page-sample-data';
import {DigitalProductPageItem as Achr45DigitalSampleMenuItem} from '../data/digital-page-data/samples/achr45-digital-page-sample-data';
import {DigitalProductPageItem as Hecwo43DigitalSampleMenuItem} from '../data/digital-page-data/samples/hecwo43-digital-page-sample-data';
import {DigitalProductPageItem as Mhq48DigitalMenuItem} from '../data/digital-page-data/mhq48-digital-page-data';
import {DigitalProductPageItem as Mfq48DigitalMenuItem} from '../data/digital-page-data/mfq48-digital-page-data';
import {DigitalProductPageItem as Mchq44DigitalMenuItem} from '../data/digital-page-data/mchq44-digital-page-data';
import {DigitalProductPageItem as Mhs49DigitalMenuItem} from '../data/digital-page-data/mhs49-digital-page-data';
import {DigitalProductPageItem as Mhr141DigitalMenuItem} from '../data/digital-page-data/mhr141-digital-page-data';
import {DigitalProductPageItem as Mchr48DigitalMenuItem} from '../data/digital-page-data/mchr48-digital-page-data';
import {DigitalProductPageItem as Mchs42DigitalMenuItem} from '../data/digital-page-data/mchs42-digital-page-data';
import {DigitalProductPageItem as Mcfr49DigitalMenuItem} from '../data/digital-page-data/mcfr49-digital-page-data';
import {DigitalProductPageItem as Mcfs42DigitalMenuItem} from '../data/digital-page-data/mcfs42-digital-page-data';
import {DigitalProductPageItem as Mfr141DigitalMenuItem} from '../data/digital-page-data/mfr141-digital-page-data';
import {DigitalProductPageItem as Mfs49DigitalMenuItem} from '../data/digital-page-data/mfs49-digital-page-data';
import {DigitalProductPageItem as Acehr43DigitalMenuItem} from '../data/digital-page-data/acehr43-digital-page-data';
import {DigitalProductPageItem as Achr45DigitalMenuItem} from '../data/digital-page-data/achr45-digital-page-data';
import {DigitalProductPageItem as Alhr42DigitalMenuItem} from '../data/digital-page-data/alhr42-digital-page-data';
import {DigitalProductPageItem as Arehr43DigitalMenuItem} from '../data/digital-page-data/arehr43-digital-page-data';
import {DigitalProductPageItem as Arhr45DigitalMenuItem} from '../data/digital-page-data/arhr45-digital-page-data';

import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import {CombinedMenuItemTypeEnum} from '../interfaces/combined-menu-item-type-enum';

export interface FriendlyUrlMapping {
  productCode: string;
  routeContext: 'products' | 'samples';
  subRoute?: string;
}

@Injectable({ providedIn: 'root' })
export class ProductDataService {
  private productApplicationIdMap: { [key: string]: any } = {
    [`products:awhr43:${MenuItemTypeEnum.QuickQuiz}`]: '222',
    [`products:awhr43:${MenuItemTypeEnum.MistakesQuiz}`]: '223',
    [`products:bafq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '178',
    [`products:bafq43:${MenuItemTypeEnum.QuickQuiz}`]: '191',
    [`products:bafq43:${MenuItemTypeEnum.MistakesQuiz}`]: '192',
    [`products:bafr43:${MenuItemTypeEnum.QuickQuiz}`]: '148',
    [`products:bafr43:${MenuItemTypeEnum.RevisionSummary}`]: '149',
    [`products:bafr43:${MenuItemTypeEnum.MistakesQuiz}`]: '150',
    [`products:baq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '179',
    [`products:baq43:${MenuItemTypeEnum.QuickQuiz}`]: '193',
    [`products:baq43:${MenuItemTypeEnum.MistakesQuiz}`]: '194',
    [`products:bar47:${MenuItemTypeEnum.QuickQuiz}`]: '145',
    [`products:bar47:${MenuItemTypeEnum.RevisionSummary}`]: '146',
    [`products:bar47:${MenuItemTypeEnum.MistakesQuiz}`]: '147',
    [`products:bas47:${MenuItemTypeEnum.QuickQuiz}`]: '145',
    [`products:bas47:${MenuItemTypeEnum.RevisionSummary}`]: '146',
    [`products:bas47:${MenuItemTypeEnum.MistakesQuiz}`]: '147',
    [`products:cafq43:${MenuItemTypeEnum.QuickQuiz}`]: '195',
    [`products:cafq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '181',
    [`products:cafq43:${MenuItemTypeEnum.MistakesQuiz}`]: '197',
    [`products:cafr43:${MenuItemTypeEnum.QuickQuiz}`]: '151',
    [`products:cafr43:${MenuItemTypeEnum.RevisionSummary}`]: '152',
    [`products:cafr43:${MenuItemTypeEnum.MistakesQuiz}`]: '153',
    [`products:caq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '181',
    [`products:caq43:${MenuItemTypeEnum.QuickQuiz}`]: '196',
    [`products:caq43:${MenuItemTypeEnum.MistakesQuiz}`]: '198',
    [`products:car47:${MenuItemTypeEnum.QuickQuiz}`]: '143',
    [`products:car47:${MenuItemTypeEnum.RevisionSummary}`]: '144',
    [`products:car47:${MenuItemTypeEnum.MistakesQuiz}`]: '142',
    [`products:cas47:${MenuItemTypeEnum.QuickQuiz}`]: '143',
    [`products:cas47:${MenuItemTypeEnum.RevisionSummary}`]: '144',
    [`products:cas47:${MenuItemTypeEnum.MistakesQuiz}`]: '142',
    [`products:das43:${MenuItemTypeEnum.QuickQuiz}`]: '122',
    [`products:das43:${MenuItemTypeEnum.RevisionSummary}`]: '127',
    [`products:das43:${MenuItemTypeEnum.MistakesQuiz}`]: '124',
    [`products:eahs44:${MenuItemTypeEnum.RevisionSummary}`]: '219',
    [`products:enar43:${MenuItemTypeEnum.RevisionSummary}`]: '218',
    [`products:enas44:${MenuItemTypeEnum.RevisionSummary}`]: '215',
    [`products:eti46:${MenuItemTypeEnum.QuickQuiz}`]: '253',
    [`products:eti46:${MenuItemTypeEnum.MistakesQuiz}`]: '270',
    [`products:etm45:${MenuItemTypeEnum.QuickQuiz}`]: '249',
    [`products:etm45:${MenuItemTypeEnum.MistakesQuiz}`]: '266',
    [`products:etr46:${MenuItemTypeEnum.QuickQuiz}`]: '250',
    [`products:etr46:${MenuItemTypeEnum.MistakesQuiz}`]: '267',
    [`products:etcc43:${MenuItemTypeEnum.QuickQuiz}`]: '254',
    [`products:etcc43:${MenuItemTypeEnum.MistakesQuiz}`]: '271',
    [`products:etjh43:${MenuItemTypeEnum.QuickQuiz}`]: '255',
    [`products:etjh43:${MenuItemTypeEnum.MistakesQuiz}`]: '272',
    [`products:etbb43:${MenuItemTypeEnum.QuickQuiz}`]: '257',
    [`products:etbb43:${MenuItemTypeEnum.MistakesQuiz}`]: '274',
    [`products:eta45:${MenuItemTypeEnum.QuickQuiz}`]: '258',
    [`products:eta45:${MenuItemTypeEnum.MistakesQuiz}`]: '275',
    [`products:etl46:${MenuItemTypeEnum.QuickQuiz}`]: '256',
    [`products:etl46:${MenuItemTypeEnum.MistakesQuiz}`]: '273',
    [`products:etf43:${MenuItemTypeEnum.QuickQuiz}`]: '262',
    [`products:etf43:${MenuItemTypeEnum.MistakesQuiz}`]: '279',
    [`products:etma43:${MenuItemTypeEnum.QuickQuiz}`]: '251',
    [`products:etma43:${MenuItemTypeEnum.MistakesQuiz}`]: '268',
    [`products:etmv43:${MenuItemTypeEnum.QuickQuiz}`]: '252',
    [`products:etmv43:${MenuItemTypeEnum.MistakesQuiz}`]: '269',
    [`products:etje43:${MenuItemTypeEnum.QuickQuiz}`]: '263',
    [`products:etje43:${MenuItemTypeEnum.MistakesQuiz}`]: '280',
    [`products:etsf43:${MenuItemTypeEnum.QuickQuiz}`]: '260',
    [`products:etsf43:${MenuItemTypeEnum.MistakesQuiz}`]: '277',
    [`products:etp46:${MenuItemTypeEnum.QuickQuiz}`]: '261',
    [`products:etp46:${MenuItemTypeEnum.MistakesQuiz}`]: '278',
    [`products:etg45:${MenuItemTypeEnum.QuickQuiz}`]: '259',
    [`products:etg45:${MenuItemTypeEnum.MistakesQuiz}`]: '276',
    [`products:far45:${MenuItemTypeEnum.QuickQuiz}`]: '100',
    [`products:far45:${MenuItemTypeEnum.RevisionSummary}`]: '101',
    [`products:far45:${MenuItemTypeEnum.MistakesQuiz}`]: '111',
    [`products:fas44:${MenuItemTypeEnum.QuickQuiz}`]: '100',
    [`products:fas44:${MenuItemTypeEnum.RevisionSummary}`]: '101',
    [`products:fas44:${MenuItemTypeEnum.MistakesQuiz}`]: '111',
    [`products:fes43:${MenuItemTypeEnum.QuickQuiz}`]: '131',
    [`products:fes43:${MenuItemTypeEnum.RevisionSummary}`]: '129',
    [`products:fes43:${MenuItemTypeEnum.MistakesQuiz}`]: '130',
    [`products:heano42:${MenuItemTypeEnum.QuickQuiz}`]: '242',
    [`products:heano42:${MenuItemTypeEnum.RevisionSummary}`]: '241',
    [`products:heano42:${MenuItemTypeEnum.MistakesQuiz}`]: '240',
    [`products:heawo43:${MenuItemTypeEnum.QuickQuiz}`]: '246',
    [`products:heawo43:${MenuItemTypeEnum.RevisionSummary}`]: '247',
    [`products:heawo43:${MenuItemTypeEnum.MistakesQuiz}`]: '248',
    [`products:hecpo43:${MenuItemTypeEnum.QuickQuiz}`]: '231',
    [`products:hecpo43:${MenuItemTypeEnum.RevisionSummary}`]: '232',
    [`products:hecpo43:${MenuItemTypeEnum.MistakesQuiz}`]: '233',
    [`products:hecwo43:${MenuItemTypeEnum.QuickQuiz}`]: '229',
    [`products:hecwo43:${MenuItemTypeEnum.RevisionSummary}`]: '228',
    [`products:hecwo43:${MenuItemTypeEnum.MistakesQuiz}`]: '230',
    [`products:heeao43:${MenuItemTypeEnum.QuickQuiz}`]: '239',
    [`products:heeao43:${MenuItemTypeEnum.RevisionSummary}`]: '237',
    [`products:heeao43:${MenuItemTypeEnum.MistakesQuiz}`]: '238',
    [`products:hembo42:${MenuItemTypeEnum.QuickQuiz}`]: '243',
    [`products:hembo42:${MenuItemTypeEnum.RevisionSummary}`]: '244',
    [`products:hembo42:${MenuItemTypeEnum.MistakesQuiz}`]: '245',
    [`products:mwhr43:${MenuItemTypeEnum.QuickQuiz}`]: '220',
    [`products:mwhr43:${MenuItemTypeEnum.MistakesQuiz}`]: '221',
    [`products:pafq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '182',
    [`products:pafq43:${MenuItemTypeEnum.QuickQuiz}`]: '199',
    [`products:pafq43:${MenuItemTypeEnum.MistakesQuiz}`]: '200',
    [`products:pafr43:${MenuItemTypeEnum.QuickQuiz}`]: '154',
    [`products:pafr43:${MenuItemTypeEnum.RevisionSummary}`]: '155',
    [`products:pafr43:${MenuItemTypeEnum.MistakesQuiz}`]: '156',
    [`products:paq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '183',
    [`products:paq43:${MenuItemTypeEnum.QuickQuiz}`]: '201',
    [`products:paq43:${MenuItemTypeEnum.MistakesQuiz}`]: '202',
    [`products:par49:${MenuItemTypeEnum.QuickQuiz}`]: '121',
    [`products:par49:${MenuItemTypeEnum.RevisionSummary}`]: '118',
    [`products:par49:${MenuItemTypeEnum.MistakesQuiz}`]: '141',
    [`products:pas49:${MenuItemTypeEnum.QuickQuiz}`]: '121',
    [`products:pas49:${MenuItemTypeEnum.RevisionSummary}`]: '118',
    [`products:pas49:${MenuItemTypeEnum.MistakesQuiz}`]: '141',
    [`products:paq72:${MenuItemTypeEnum.QuickQuiz}`]: '290',
    [`products:paq72:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '291',
    [`products:par74:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '286',
    [`products:par74:${MenuItemTypeEnum.QuickQuiz}`]: '284',
    [`products:par74:${MenuItemTypeEnum.MistakesQuiz}`]: '285',
    [`products:baq72:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '287',
    [`products:bar74:${MenuItemTypeEnum.QuickQuiz}`]: '292',
    [`products:bar74:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '294',
    [`products:bar74:${MenuItemTypeEnum.MistakesQuiz}`]: '293',
    [`products:caq72:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '289',
    [`products:caq72:${MenuItemTypeEnum.QuickQuiz}`]: '288',
    [`products:car74:${MenuItemTypeEnum.QuickQuiz}`]: '281',
    [`products:car74:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '283',
    [`products:car74:${MenuItemTypeEnum.MistakesQuiz}`]: '282',

    // TEST PRODUCTS
    [`products:trhp20:${MenuItemTypeEnum.MistakesQuiz}`]: '010',
    [`products:trhp20:${MenuItemTypeEnum.QuickQuiz}`]: '011',
    [`products:trhp20:${MenuItemTypeEnum.RevisionSummary}`]: '012',
    [`products:trhp20:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '013',
    [`products:trhp21:${MenuItemTypeEnum.MistakesQuiz}`]: '014',
    [`products:trhp21:${MenuItemTypeEnum.QuickQuiz}`]: '015',
    [`products:trhp21:${MenuItemTypeEnum.RevisionSummary}`]: '016',
    [`products:trhp21:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '017',
    [`products:trhp22:${MenuItemTypeEnum.MistakesQuiz}`]: '018',
    [`products:trhp22:${MenuItemTypeEnum.QuickQuiz}`]: '019',
    [`products:trhp22:${MenuItemTypeEnum.RevisionSummary}`]: '020',
    [`products:trhp22:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '021',
    [`products:trhp23:${MenuItemTypeEnum.MistakesQuiz}`]: '022',
    [`products:trhp23:${MenuItemTypeEnum.QuickQuiz}`]: '023',
    [`products:trhp23:${MenuItemTypeEnum.RevisionSummary}`]: '024',
    [`products:trhp23:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '025',
    [`products:trhp24:${MenuItemTypeEnum.MistakesQuiz}`]: '026',
    [`products:trhp24:${MenuItemTypeEnum.QuickQuiz}`]: '027',
    [`products:trhp24:${MenuItemTypeEnum.RevisionSummary}`]: '028',
    [`products:trhp24:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '029',
    [`products:trhp25:${MenuItemTypeEnum.MistakesQuiz}`]: '030',
    [`products:trhp25:${MenuItemTypeEnum.QuickQuiz}`]: '031',
    [`products:trhp25:${MenuItemTypeEnum.RevisionSummary}`]: '032',
    [`products:trhp25:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '033',
    [`products:trhp26:${MenuItemTypeEnum.MistakesQuiz}`]: '034',
    [`products:trhp26:${MenuItemTypeEnum.QuickQuiz}`]: '035',
    [`products:trhp26:${MenuItemTypeEnum.RevisionSummary}`]: '036',
    [`products:trhp26:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '037',
    [`products:trhp27:${MenuItemTypeEnum.MistakesQuiz}`]: '038',
    [`products:trhp27:${MenuItemTypeEnum.QuickQuiz}`]: '039',
    [`products:trhp27:${MenuItemTypeEnum.RevisionSummary}`]: '040',
    [`products:trhp27:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '041',
    [`products:trhp28:${MenuItemTypeEnum.MistakesQuiz}`]: '042',
    [`products:trhp28:${MenuItemTypeEnum.QuickQuiz}`]: '043',
    [`products:trhp28:${MenuItemTypeEnum.RevisionSummary}`]: '044',
    [`products:trhp28:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '045',
    [`products:trhp29:${MenuItemTypeEnum.MistakesQuiz}`]: '046',
    [`products:trhp29:${MenuItemTypeEnum.QuickQuiz}`]: '047',
    [`products:trhp29:${MenuItemTypeEnum.RevisionSummary}`]: '048',
    [`products:trhp29:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '049',

    [`samples:enar43:${MenuItemTypeEnum.RevisionSummary}`]: '218',
    [`samples:car47:${MenuItemTypeEnum.QuickQuiz}`]: '175',
    [`samples:car47:${MenuItemTypeEnum.RevisionSummary}`]: '176',
    [`samples:bar47:${MenuItemTypeEnum.QuickQuiz}`]: '175',
    [`samples:bar47:${MenuItemTypeEnum.RevisionSummary}`]: '176',
    [`samples:par47:${MenuItemTypeEnum.QuickQuiz}`]: '175',
    [`samples:par47:${MenuItemTypeEnum.RevisionSummary}`]: '176',
    [`samples:fas44:${MenuItemTypeEnum.QuickQuiz}`]: '103',
    [`samples:fas44:${MenuItemTypeEnum.RevisionSummary}`]: '104',
    [`samples:spas43:${MenuItemTypeEnum.QuickQuiz}`]: '110',
    [`samples:spas43:${MenuItemTypeEnum.RevisionSummary}`]: '108',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '175',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '176',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '175',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '176',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '175',
    [`samples:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '176',
    [`samples:das43:${MenuItemTypeEnum.QuickQuiz}`]: '',
    [`samples:das43:${MenuItemTypeEnum.RevisionSummary}`]: '',
    [`samples:paq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '183',
    [`samples:paq43:${MenuItemTypeEnum.QuickQuiz}`]: '227',
    [`samples:baq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '179',
    [`samples:baq43:${MenuItemTypeEnum.QuickQuiz}`]: '227',
    [`samples:caq43:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '181',
    [`samples:caq43:${MenuItemTypeEnum.QuickQuiz}`]: '227',
    [`samples:hecwo43:${MenuItemTypeEnum.QuickQuiz}`]: '264',
    [`samples:hecwo43:${MenuItemTypeEnum.RevisionSummary}`]: '265',

    [`products:spar42:${MenuItemTypeEnum.QuickQuiz}`]: '109',
    [`products:spar42:${MenuItemTypeEnum.RevisionSummary}`]: '107',
    [`products:spar42:${MenuItemTypeEnum.MistakesQuiz}`]: '114',
    [`products:spas43:${MenuItemTypeEnum.QuickQuiz}`]: '109',
    [`products:spas43:${MenuItemTypeEnum.RevisionSummary}`]: '107',
    [`products:spas43:${MenuItemTypeEnum.MistakesQuiz}`]: '114',
    [`products:sper42:${MenuItemTypeEnum.QuickQuiz}`]: '135',
    [`products:sper42:${MenuItemTypeEnum.RevisionSummary}`]: '137',
    [`products:sper42:${MenuItemTypeEnum.MistakesQuiz}`]: '138',
    [`products:spes43:${MenuItemTypeEnum.QuickQuiz}`]: '135',
    [`products:spes43:${MenuItemTypeEnum.RevisionSummary}`]: '137',
    [`products:spes43:${MenuItemTypeEnum.MistakesQuiz}`]: '138',
    [`products:dar42:${MenuItemTypeEnum.QuickQuiz}`]: '122',
    [`products:dar42:${MenuItemTypeEnum.RevisionSummary}`]: '127',
    [`products:dar42:${MenuItemTypeEnum.MistakesQuiz}`]: '124',
    [`products:fer42:${MenuItemTypeEnum.QuickQuiz}`]: '131',
    [`products:fer42:${MenuItemTypeEnum.RevisionSummary}`]: '129',
    [`products:fer42:${MenuItemTypeEnum.MistakesQuiz}`]: '130',

    [`products:safq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Biology}`]:
      '184',
    [`products:safq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '204',
    [`products:safq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '203',
    [`products:safq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '185',
    [`products:safq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '206',
    [`products:safq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '205',
    [`products:safq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Physics}`]:
      '186',
    [`products:safq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '208',
    [`products:safq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '207',

    [`products:safr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '160',
    [`products:safr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '157',
    [`products:safr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '163',

    [`products:safr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '161',
    [`products:safr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '158',
    [`products:safr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '164',

    [`products:safr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '162',
    [`products:safr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '159',
    [`products:safr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '165',

    [`products:sahq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Biology}`]:
      '187',
    [`products:sahq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '210',
    [`products:sahq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '209',
    [`products:sahq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '188',
    [`products:sahq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '212',
    [`products:sahq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '211',
    [`products:sahq43:${MenuItemTypeEnum.CombinedExamPracticeQuestions}:${CombinedMenuItemTypeEnum.Physics}`]:
      '189',
    [`products:sahq43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '214',
    [`products:sahq43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '213',
    [`products:sahr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '172',
    [`products:sahr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '166',
    [`products:sahr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '169',
    [`products:sahr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '173',
    [`products:sahr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '167',
    [`products:sahr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '170',
    [`products:sahr47:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '174',
    [`products:sahr47:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '168',
    [`products:sahr47:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '171',
    [`products:scafs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '160',
    [`products:scafs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '158',
    [`products:scafs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '161',
    [`products:scafs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '157',
    [`products:scafs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '162',
    [`products:scafs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '159',
    [`products:scafs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '163',
    [`products:scafs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '164',
    [`products:scafs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '165',
    [`products:scahs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '172',
    [`products:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '166',
    [`products:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Biology}`]:
      '169',
    [`products:scahs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '173',
    [`products:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '167',
    [`products:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Chemistry}`]:
      '170',
    [`products:scahs43:${MenuItemTypeEnum.CombinedMistakesQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '174',
    [`products:scahs43:${MenuItemTypeEnum.CombinedQuickQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '168',
    [`products:scahs43:${MenuItemTypeEnum.CombinedRevisionSummaryQuiz}:${CombinedMenuItemTypeEnum.Physics}`]:
      '171',
    [`products:hembo43:${MenuItemTypeEnum.QuickQuiz}`]: '243',
    [`products:hembo43:${MenuItemTypeEnum.RevisionSummary}`]: '244',
    [`products:hembo43:${MenuItemTypeEnum.MistakesQuiz}`]: '245',
    [`products:hewno43:${MenuItemTypeEnum.QuickQuiz}`]: '234',
    [`products:hewno43:${MenuItemTypeEnum.RevisionSummary}`]: '235',
    [`products:hewno43:${MenuItemTypeEnum.MistakesQuiz}`]: '236',
    [`products:heano43:${MenuItemTypeEnum.QuickQuiz}`]: '242',
    [`products:heano43:${MenuItemTypeEnum.RevisionSummary}`]: '241',
    [`products:heano43:${MenuItemTypeEnum.MistakesQuiz}`]: '240',
    [`products:mhq48:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '301',
    [`products:mchq44:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '302',
    [`products:mfq48:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '303',
    [`products:mcfq44:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '304',
    [`samples:mhq48:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '-301',
    [`samples:mfq48:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '-303',
    [`samples:eti46:${MenuItemTypeEnum.QuickQuiz}`]: '-253',
    [`samples:bar74:${MenuItemTypeEnum.QuickQuiz}`]: '-292',
    [`samples:bar74:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '-294',
    [`samples:caq72:${MenuItemTypeEnum.QuickQuiz}`]: '-288',
    [`samples:caq72:${MenuItemTypeEnum.ExamPracticeQuestions}`]: '-289',
    // GCSE Maths RG and CR&P Application Maps
    [`products:mhr141:${MenuItemTypeEnum.QuickQuiz}`]: '295',
    [`products:mhr141:${MenuItemTypeEnum.MistakesQuiz}`]: '296',
    [`products:mhr141:${MenuItemTypeEnum.RevisionSummary}`]: '297',
    [`products:mchr48:${MenuItemTypeEnum.QuickQuiz}`]: '298',
    [`products:mchr48:${MenuItemTypeEnum.MistakesQuiz}`]: '299',
    [`products:mchr48:${MenuItemTypeEnum.RevisionSummary}`]: '300',
    [`products:mhs49:${MenuItemTypeEnum.QuickQuiz}`]: '295',
    [`products:mhs49:${MenuItemTypeEnum.MistakesQuiz}`]: '296',
    [`products:mhs49:${MenuItemTypeEnum.RevisionSummary}`]: '297'


  };

  private productMenuMap: { [key: string]: any } = {
    'products:fas44': Fas44MenuItems,
    'products:fas45': Fas45MenuItems,
    'products:far45': Far45MenuItems,
    'products:bafq43': Bafq43MenuItems,
    'products:bafr43': Bafr43MenuItems,
    'products:baq43': Baq43bMenuItems,
    'products:bar47': Bar47MenuItems,
    'products:bas47': Bas47MenuItems,
    'products:cafq43': Cafq43MenuItems,
    'products:cafr43': Cafr43MenuItems,
    'products:caq43': Caq43bMenuItems,
    'products:car47': Car47MenuItems,
    'products:cas47': Cas47MenuItems,
    'products:enar43': Enar43MenuItems,
    'products:enas44': Enas44MenuItems,
    'products:daq42': Daq42MenuItems,
    'products:dar42': Dar42MenuItems,
    'products:das43': Das43MenuItems,
    'products:awhr43': Awhr43MenuItems,
    'products:eahs44': Eahs44MenuItems,
    'products:faq42': Faq42MenuItems,
    'products:feq42': Feq42MenuItems,
    'products:fer42': Fer42MenuItems,
    'products:fes43': Fes43MenuItems,
    'products:heano42': Heano42MenuItems,
    'products:heano43': Heano43MenuItems,
    'products:mwhr43': Mwhr43MenuItems,
    'products:pafq43': Pafq43MenuItems,
    'products:pafr43': Pafr43MenuItems,
    'products:paq43': Paq43bMenuItems,
    'products:par49': Par49MenuItems,
    'products:pas49': Pas49MenuItems,
    'products:safq43': Safq43bMenuItems,
    'products:safr47': Safr47MenuItems,
    'products:sahq43': Sahq43bMenuItems,
    'products:sahr47': Sahr47MenuItems,
    'products:scafs43': Scafs43MenuItems,
    'products:scahs43': Scahs43MenuItems,
    'products:spaq42': Spaq42MenuItems,
    'products:spar42': Spar42MenuItems,
    'products:spas43': Spas43MenuItems,
    'products:speq42': Speq42MenuItems,
    'products:sper42': Sper42MenuItems,
    'products:spes43': Spes43MenuItems,
    'samples:fas44': Fas44SampleMenuItems,
    'samples:car47': Car47SampleMenuItems,
    'samples:enar43': Enar43SampleMenuItems,
    'samples:das43': Das43SampleMenuItems,
    'samples:spas43': Spas43SampleMenuItems,
    'samples:scahs43': Scahs43SampleMenuItems,
    'samples:paq43': Paq43SampleMenuItems,
    'samples:baq43': Baq43SampleMenuItems,
    'samples:caq43': Caq43SampleMenuItems,
    'samples:bar47': Bar47SampleMenuItems,
    'samples:bar74': Bar74SampleMenuItems,
    'samples:caq72': Caq72SampleMenuItems,
    'samples:eti46': Eti46SampleMenuItems,
    'samples:mfq48': MFQ48SampleMenuItems,
    'products:trhp20': Trhp20MenuItems,
    'products:trhp21': Trhp21MenuItems,
    'products:trhp22': Trhp22MenuItems,
    'products:trhp23': Trhp23MenuItems,
    'products:trhp24': Trhp24MenuItems,
    'products:trhp25': Trhp25MenuItems,
    'products:trhp26': Trhp26MenuItems,
    'products:trhp27': Trhp27MenuItems,
    'products:trhp28': Trhp28MenuItems,
    'products:trhp29': Trhp29MenuItems,
    'products:heawo43': Heawo43MenuItems,
    'products:hecpo43': Hecpo43MenuItems,
    'products:eti46': Eti46MenuItems,
    'products:hembo43': Hembo43MenuItems,
    'products:hewno43': Hewno43MenuItems,
    'products:hecwo43': Hecwo43MenuItems,
    'products:heeao43': Heeao43MenuItems,
    'products:etm45': Etm45MenuItems,
    'products:etcc43': Etcc43MenuItems,
    'products:etr46': Etr46MenuItems,
    'products:etjh43': Etjh43MenuItems,
    'products:etbb43': Etbb43MenuItems,
    'products:eta45': Eta45MenuItems,
    'products:etl46': Etl46MenuItems,
    'products:etf43': Etf43MenuItems,
    'products:etma43': Etma43MenuItems,
    'products:etmv43': Etmv43MenuItems,
    'products:etje43': Etje43MenuItems,
    'products:etsf43': Etsf43MenuItems,
    'products:etp46': Etp46MenuItems,
    'products:etg45': Etg45MenuItems,
    'products:baq72': Baq72MenuItems,
    'products:bar74': Bar74MenuItems,
    'products:caq72': Caq72MenuItems,
    'products:car74': Car74MenuItems,
    'products:paq72': Paq72MenuItems,
    'products:par74': Par74MenuItems,
    'products:mcfq44': Mcfq44MenuItems,
    'products:mhq48': Mhq48MenuItems,
    'products:mfq48': Mfq48MenuItems,
    'products:mchq44': Mchq44MenuItems,
    'products:mhs49': Mhs49MenuItems,
    'products:mhr141': Mhr141MenuItems,
    'products:mchr48': Mchr48MenuItems,
    'products:mchs42': Mchs42MenuItems,
    'products:mcfr49': Mcfr49MenuItems,
    'products:mcfs42': Mcfs42MenuItems,
    'products:mfr141': Mfr141MenuItems,
    'products:mfs49': Mfs49MenuItems,
    'products:acehr43': Acehr43MenuItems,
    'products:achr45': Achr45MenuItems,
    'products:alhr42': Alhr42MenuItems,
    'products:arehr43': Arehr43MenuItems,
    'products:arhr45': Arhr45MenuItems,
    'samples:mhq48': MHQ48SampleMenuItems,
    'samples:achr45': Achr45SampleMenuItems,
    'samples:hecwo43': Hecwo43SampleMenuItems,
  };

  private digitalProductMenuMap: { [key: string]: any } = {
    'products:fas44': Fas44DigitalMenuItem,
    'products:fas45': Fas45DigitalMenuItem,
    'products:far45': Far45DigitalMenuItem,
    'products:enar43': Enar43DigitalMenuItem,
    'products:daq42': Daq42DigitalMenuItem,
    'products:awhr43': Awhr43DigitalMenuItem,
    'products:heano42': Heano42DigitalMenuItem,
    'products:heano43': Heano43DigitalMenuItem,
    'products:car47': Car47DigitalMenuItem,
    'products:bafq43': Bafq43DigitalMenuItem,
    'products:bafr43': Bafr43DigitalMenuItem,
    'products:baq43': Baq43bDigitalMenuItem,
    'products:bar47': Bar47DigitalMenuItem,
    'products:bas47': Bas47DigitalMenuItem,
    'products:cafq43': Cafq43DigitalMenuItem,
    'products:cafr43': Cafr43DigitalMenuItem,
    'products:caq43': Caq43bDigitalMenuItem,
    'products:cas47': Cas47DigitalMenuItem,
    'products:dar42': Dar42DigitalMenuItem,
    'products:das43': Das43DigitalMenuItem,
    'products:enas44': Enas44DigitalMenuItem,
    'products:faq42': Faq42DigitalMenuItem,
    'products:feq42': Feq42DigitalMenuItem,
    'products:fer42': Fer42DigitalMenuItem,
    'products:fes43': Fes43DigitalMenuItem,
    'products:pafq43': Pafq43DigitalMenuItem,
    'products:pafr43': Pafr43DigitalMenuItem,
    'products:paq43': Paq43bDigitalMenuItem,
    'products:par49': Par49DigitalMenuItem,
    'products:pas49': Pas49DigitalMenuItem,
    'products:safq43': Safq43bDigitalMenuItem,
    'products:safr47': Safr47DigitalMenuItem,
    'products:sahq43': Sahq43bDigitalMenuItem,
    'products:sahr47': Sahr47DigitalMenuItem,
    'products:scafs43': Scafs43DigitalMenuItem,
    'products:scahs43': Scahs43DigitalMenuItem,
    'products:spaq42': Spaq42DigitalMenuItem,
    'products:spar42': Spar42DigitalMenuItem,
    'products:spas43': Spas43DigitalMenuItem,
    'products:speq42': Speq42DigitalMenuItem,
    'products:sper42': Sper42DigitalMenuItem,
    'products:spes43': Spes43DigitalMenuItem,
    'products:eahs44': Eahs44DigitalMenuItem,
    'products:mwhr43': Mwhr43DigitalMenuItem,
    'samples:fas44': Fas44DigitalSampleMenuItem,
    'samples:car47': Car47DigitalSampleMenuItem,
    'samples:enar43': Enar43DigitalSampleMenuItem,
    'samples:das43': Das43DigitalSampleMenuItem,
    'samples:spas43': Spas43DigitalSampleMenuItem,
    'samples:scahs43': Scahs43DigitalSampleMenuItem,
    'samples:paq43': Paq43DigitalSampleMenuItem,
    'samples:baq43': Baq43DigitalSampleMenuItem,
    'samples:caq43': Caq43DigitalSampleMenuItem,
    'samples:bar47': Bar47DigitalSampleMenuItem,
    'samples:bar74': Bar74DigitalSampleMenuItem,
    'samples:caq72': Caq72DigitalSampleMenuItem,
    'samples:eti46': Eti46DigitalSampleMenuItem,
    'samples:mfq48': MFQ48DigitalSampleMenuItem,
    'samples:mchq44': Mchq44DigitalSampleMenuItem,
    'samples:mcfq44': Mcfq44DigitalSampleMenuItem,
    'samples:achr45': Achr45DigitalSampleMenuItem,
    'samples:hecwo43': Hecwo43DigitalSampleMenuItem,
    'products:trhp20': Trhp20DigitalMenuItem,
    'products:trhp21': Trhp21DigitalMenuItem,
    'products:trhp22': Trhp22DigitalMenuItem,
    'products:trhp23': Trhp23DigitalMenuItem,
    'products:trhp24': Trhp24DigitalMenuItem,
    'products:trhp25': Trhp25DigitalMenuItem,
    'products:trhp26': Trhp26DigitalMenuItem,
    'products:trhp27': Trhp27DigitalMenuItem,
    'products:trhp28': Trhp28DigitalMenuItem,
    'products:trhp29': Trhp29DigitalMenuItem,
    'products:heawo43': Heawo43DigitalMenuItem,
    'products:hecpo43': Hecpo43DigitalMenuItem,
    'products:eti46': Eti46DigitalMenuItem,
    'products:hembo43': Hembo43DigitalMenuItem,
    'products:hewno43': Hewno43DigitalMenuItem,
    'products:hecwo43': Hecwo43DigitalMenuItem,
    'products:heeao43': Heeao43DigitalMenuItem,
    'products:etm45': Etm45DigitalMenuItem,
    'products:etcc43': Etcc43DigitalMenuItem,
    'products:etr46': Etr46DigitalMenuItem,
    'products:etjh43': Etjh43DigitalMenuItem,
    'products:etbb43': Etbb43DigitalMenuItem,
    'products:eta45': Eta45DigitalMenuItem,
    'products:etl46': Etl46DigitalMenuItem,
    'products:etf43': Etf43DigitalMenuItem,
    'products:etma43': Etma43DigitalMenuItem,
    'products:etmv43': Etmv43DigitalMenuItem,
    'products:etje43': Etje43DigitalMenuItem,
    'products:etsf43': Etsf43DigitalMenuItem,
    'products:etp46': Etp46DigitalMenuItem,
    'products:etg45': Etg45DigitalMenuItem,
    'products:baq72': Baq72DigitalMenuItem,
    'products:bar74': Bar74DigitalMenuItem,
    'products:caq72': Caq72DigitalMenuItem,
    'products:car74': Car74DigitalMenuItem,
    'products:paq72': Paq72DigitalMenuItem,
    'products:par74': Par74DigitalMenuItem,
    'products:mcfq44': Mcfq44DigitalMenuItem,
    'products:mhq48': Mhq48DigitalMenuItem,
    'products:mfq48': Mfq48DigitalMenuItem,
    'products:mchq44': Mchq44DigitalMenuItem,
    'products:mhs49': Mhs49DigitalMenuItem,
    'products:mhr141': Mhr141DigitalMenuItem,
    'products:mchr48': Mchr48DigitalMenuItem,
    'products:mchs42': Mchs42DigitalMenuItem,
    'products:mcfr49': Mcfr49DigitalMenuItem,
    'products:mcfs42': Mcfs42DigitalMenuItem,
    'products:mfr141': Mfr141DigitalMenuItem,
    'products:mfs49': Mfs49DigitalMenuItem,
    'products:acehr43': Acehr43DigitalMenuItem,
    'products:achr45': Achr45DigitalMenuItem,
    'products:alhr42': Alhr42DigitalMenuItem,
    'products:arehr43': Arehr43DigitalMenuItem,
    'products:arhr45': Arhr45DigitalMenuItem,
    'samples:mhq48': MHQ48DigitalSampleMenuItem
  };

  // ---------------------------------------------------------------------------
  // Shared hub mappings
  // Map a product code to the code whose hub it shares, when two or more products
  // serve the same online content. The codes need not be related: CAS47 (Complete
  // Revision & Practice) and CAR47 (Revision Guide) are different books sharing one
  // hub, and a new edition reusing an existing hub is the same relationship.
  //
  // Keys and values are lowercase product codes. Identity is the default, so a
  // product whose hub sits under its own code needs no entry here.
  //
  // e.g. 'cas47': 'car47'   // Complete Revision & Practice reuses the Revision Guide hub
  //
  // A licence for a mapped product redeems the hub it maps to. The landing-page tile
  // keeps the licence's own cover image but links to the hub's Universal Resource
  // Locator (URL), so content, menu and progress all live under the hub's code. This
  // is not a redirect: no page is served under the mapped product's code, and nothing
  // should be added to forward from it.
  //
  // A URL under a mapped product's code redirects to the hub's code
  // (ProductCodeSanitizerGuard), so the data lookups below only ever see hub codes and
  // do not fall back through this map.
  // ---------------------------------------------------------------------------
  private readonly sharedHubMap: Record<string, string> = {
    'eahs45': 'eahs44',
    'mqhs46': 'mhs49',
    'mxhs45': 'mhs49',
    'mqhr48': 'mhr141',
    'mxhr48': 'mhr141',
    'enar44': 'enar43',
    'mqfr48': 'mfr141',
    'mxfr48': 'mfr141',
    'mqfs44': 'mfs49',
    'mxfs43': 'mfs49',
    'mqfq45': 'mfq48',
    'mxfq44': 'mfq48',
    'mxhq44': 'mhq48',
    'mqhq45': 'mhq48'
  };

  /**
   * The code whose hub data serves this product.
   *
   * A product with no sharedHubMap entry serves its own hub, so this returns the code
   * it was given. That means callers never have to check for a missing mapping - the
   * result is always a code they can look up directly.
   */
  resolveHubCode(productCode: string): string {
    const code = productCode.toLowerCase();
    const sharedHubCode = this.sharedHubMap[code];

    if (sharedHubCode) {
      return sharedHubCode;
    }

    return code;
  }

  getMenuItemsWithContext(
    productCode: string,
    routeContext: 'products' | 'samples' = 'products',
  ): any {
    const key = `${routeContext}:${productCode.toLowerCase()}`;
    //console.log(`Looking up menu items with key: ${key}`);
    const menuItems = this.productMenuMap[key];
    //console.log(`Found menu items:`, menuItems);

    return menuItems ? menuItems : null;
  }

  getDigitalPageDataWithContext(
    productCode: string,
    routeContext: 'products' | 'samples' = 'products',
  ): any {
    const key = `${routeContext}:${productCode.toLowerCase()}`;
    const pageData = this.digitalProductMenuMap[key];

    return pageData ? pageData : null;
  }

  getApplicationIdForProduct(
    productCode: string,
    routeContext: 'products' | 'samples' = 'products',
    menuItemType: MenuItemTypeEnum,
    combinedMenuItemTypeEnum?: CombinedMenuItemTypeEnum,
  ): any {
    // Application ids are keyed by quiz type, and combined tests (Combined Science and
    // the like) add the subject on top.
    let keySuffix = `${menuItemType}`;
    if (combinedMenuItemTypeEnum) {
      keySuffix = `${menuItemType}:${combinedMenuItemTypeEnum}`;
    }

    const key = `${routeContext}:${productCode.toLowerCase()}:${keySuffix}`;
    const applicationId = this.productApplicationIdMap[key];

    return applicationId ? applicationId : null;
  }

  // ---------------------------------------------------------------------------
  // Friendly URL mappings
  // Map a human-readable slug (case-insensitive) to a canonical product route.
  // e.g. /Bonjour -> /products/fas44,  /Berlin -> /products/dar42
  // Add new entries here to register additional friendly URLs.
  // ---------------------------------------------------------------------------
  private readonly friendlyUrlMap: Record<string, FriendlyUrlMapping> = {
    bonjour: { productCode: 'fas44', routeContext: 'products' },
    berlin: { productCode: 'dar42', routeContext: 'products' },
    madrid: { productCode: 'spas43', routeContext: 'products' },
    bueno: { productCode: 'spar42', routeContext: 'products' },
    merci: { productCode: 'fes43', routeContext: 'products' },
    hallo: { productCode: 'das43', routeContext: 'products' },
    bon: { productCode: 'fer42', routeContext: 'products' },
    hola: { productCode: 'spes43', routeContext: 'products' },
    gracias: { productCode: 'sper42', routeContext: 'products' },
    cafe: { productCode: 'faq42', routeContext: 'products' },
    atom: { productCode: 'car47', routeContext: 'products' },
    acid: { productCode: 'cafr43', routeContext: 'products' },
    force: { productCode: 'par49', routeContext: 'products' },
    base: { productCode: 'cas47', routeContext: 'products' },
    mass: { productCode: 'pafr43', routeContext: 'products' },
    light: { productCode: 'pas49', routeContext: 'products' },
    cell: { productCode: 'bar47', routeContext: 'products' },
    plant: { productCode: 'bafr43', routeContext: 'products' },
    leaf: { productCode: 'bas47', routeContext: 'products' },
    zinc: { productCode: 'sahr47', routeContext: 'products' },
    gold: { productCode: 'safr47', routeContext: 'products' },
    carbon: { productCode: 'scafs43', routeContext: 'products' },
    neon: { productCode: 'scahs43', routeContext: 'products' },
    chic: { productCode: 'feq42', routeContext: 'products' },
    headline: { productCode: 'enas44', routeContext: 'products' },
    narrator: { productCode: 'enar43', routeContext: 'products' },
    narratoranswers: { productCode: 'enar43', routeContext: 'products', subRoute: 'answers' },
    blurb: { productCode: 'eahs44', routeContext: 'products' },
    tapas: { productCode: 'spaq42', routeContext: 'products' },
    haus: { productCode: 'daq42', routeContext: 'products' },
    fiesta: { productCode: 'speq42', routeContext: 'products' },
    gene: { productCode: 'baq43', routeContext: 'products' },
    mole: { productCode: 'caq43', routeContext: 'products' },
    wave: { productCode: 'paq43', routeContext: 'products' },
    root: { productCode: 'bafq43', routeContext: 'products' },
    gas: { productCode: 'cafq43', routeContext: 'products' },
    energy: { productCode: 'pafq43', routeContext: 'products' },
    field: { productCode: 'safq43', routeContext: 'products' },
    sum: { productCode: 'mwhr43', routeContext: 'products' },
    verse: { productCode: 'awhr43', routeContext: 'products' },
    medicine: { productCode: 'hembo43', routeContext: 'products' },
    weimargermany: { productCode: 'hewno43', routeContext: 'products' },
    anglosaxon: { productCode: 'heano43', routeContext: 'products' },
    americanwest: { productCode: 'heawo43', routeContext: 'products' },
    crime: { productCode: 'hecpo43', routeContext: 'products' },
    coldwar: { productCode: 'hecwo43', routeContext: 'products' },
    elizabethan: { productCode: 'heeao43', routeContext: 'products' },
    rock: { productCode: 'sahq43', routeContext: 'products' },
    macbeth: { productCode: 'etm45', routeContext: 'products' },
    macbethextras: { productCode: 'etm45', routeContext: 'products', subRoute: 'extras' },
    scrooge: { productCode: 'etcc43', routeContext: 'products' },
    scroogeextras: { productCode: 'etcc43', routeContext: 'products', subRoute: 'extras' },
    romeo: { productCode: 'etr46', routeContext: 'products' },
    romeoextras: { productCode: 'etr46', routeContext: 'products', subRoute: 'extras' },
    hyde: { productCode: 'etjh43', routeContext: 'products' },
    hydeextras: { productCode: 'etjh43', routeContext: 'products', subRoute: 'extras' },
    mickey: { productCode: 'etbb43', routeContext: 'products' },
    mickeyextras: { productCode: 'etbb43', routeContext: 'products', subRoute: 'extras' },
    boxer: { productCode: 'eta45', routeContext: 'products' },
    boxerextras: { productCode: 'eta45', routeContext: 'products', subRoute: 'extras' },
    ralph: { productCode: 'etl46', routeContext: 'products' },
    ralphextras: { productCode: 'etl46', routeContext: 'products', subRoute: 'extras' },
    frankenstein: { productCode: 'etf43', routeContext: 'products' },
    frankensteinextras: { productCode: 'etf43', routeContext: 'products', subRoute: 'extras' },
    beatrice: { productCode: 'etma43', routeContext: 'products' },
    beatriceextras: { productCode: 'etma43', routeContext: 'products', subRoute: 'extras' },
    portia: { productCode: 'etmv43', routeContext: 'products' },
    portiaextras: { productCode: 'etmv43', routeContext: 'products', subRoute: 'extras' },
    jane: { productCode: 'etje43', routeContext: 'products' },
    janeextras: { productCode: 'etje43', routeContext: 'products', subRoute: 'extras' },
    sherlock: { productCode: 'etsf43', routeContext: 'products' },
    sherlockextras: { productCode: 'etsf43', routeContext: 'products', subRoute: 'extras' },
    mrdarcy: { productCode: 'etp46', routeContext: 'products' },
    mrdarcyextras: { productCode: 'etp46', routeContext: 'products', subRoute: 'extras' },
    pip: { productCode: 'etg45', routeContext: 'products' },
    pipextras: { productCode: 'etg45', routeContext: 'products', subRoute: 'extras' },
    mrbirling: { productCode: 'eti46', routeContext: 'products' },
    mrbirlingextras: { productCode: 'eti46', routeContext: 'products', subRoute: 'extras' },
    genome: { productCode: 'baq72', routeContext: 'products' },
    amino: { productCode: 'bar74', routeContext: 'products' },
    bond: { productCode: 'caq72', routeContext: 'products' },
    helium: { productCode: 'car74', routeContext: 'products' },
    gravity: { productCode: 'paq72', routeContext: 'products' },
    density: { productCode: 'par74', routeContext: 'products' },
    ratio: { productCode: 'mcfq44', routeContext: 'products' },
    decimal: { productCode: 'mhq48', routeContext: 'products' },
    equation: { productCode: 'mfq48', routeContext: 'products' },
    division: { productCode: 'mchq44', routeContext: 'products' },
    volta: { productCode: 'acehr43', routeContext: 'products' },
    rhyme: { productCode: 'achr45', routeContext: 'products' },
    stanza: { productCode: 'alhr42', routeContext: 'products' },
    ballad: { productCode: 'arehr43', routeContext: 'products' },
    sonnet: { productCode: 'arhr45', routeContext: 'products' },
    area: { productCode: 'mhr141', routeContext: 'products' },
    chart: { productCode: 'mhs49', routeContext: 'products' },
    circle: { productCode: 'mfs49', routeContext: 'products' },
    graph: { productCode: 'mfr141', routeContext: 'products' },
    factor: { productCode: 'mchs42', routeContext: 'products' },
    prime: { productCode: 'mchr48', routeContext: 'products' },
    table: { productCode: 'mcfs42', routeContext: 'products' },
    solve: { productCode: 'mcfr49', routeContext: 'products' },
    // we don't have any current products that redirect to a specific component
    // but here's an example of HOW to do it. All logic is now in place for that
    // rockextras: { productCode: 'sahq43', routeContext: 'products', subRoute: 'extras' },
  };

  resolveFriendlyUrl(slug: string): FriendlyUrlMapping | null {
    return this.friendlyUrlMap[slug.toLowerCase()] ?? null;
  }
}


